/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：276
 */

"use strict"

var r
export { r as a };
(function (e) {
  e.USER_NOT_LOGIN = "USER_NOT_LOGIN"
  e.USER_CANCEL_SAVE = "USER_CANCEL_SAVE"
  e.SAVE_PROJECT_ERROR = "SAVE_PROJECT_ERROR"
  e.UPDATE_PROJECT_ERROR = "UPDATE_PROJECT_ERROR"
  e.CLOUD_SPACE_DATA_ERROR = "CLOUD_SPACE_DATA_ERROR"
})(r || (r = {}))
export default r
